import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import withLayout from '../../../hocs/Layout';
import { apiConstants, post, get } from '../../../common/constants';
import { getMerchant } from '../../../helpers/ReduxHelpers';
import { findInObjArr, titleCase } from '../../../helpers/UtilityHelper';
import Loader from '../../../common/Loader';
import UserNotFound from './userNotFound';
import AddUser from './addUser';
import AddApiUser from './addApiUser';
import UserList from './userList';
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import PageTitle from '../../../common/PageTitle';
import PageHero from '../../../common/PageHero';

const MerchantUsers = () => {
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [showApiUser, setShowApiUser] = useState(false);
    const [userList, setUsers] = useState(false);
    const [moduleList, setModules] = useState([]);
    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''
    const [reload, setReload] = useState(0);

    const [currentId, setCurrentId] = useState();

    const handleClose = () => setShow(false);

    const handleShow = () => setShow(true);

    const handleCloseApiUser = () => setShowApiUser(false);

    const handleShowApiUser = () => setShowApiUser(true);

    const loadUsers = () => {
        setLoading(true);
        get(`${apiConstants.BASE_LOCAL}${apiConstants.GET_MERCHANT_USERS}/?merchantid=${merchantId}`).then(response => {
            setLoading(false);
            setUsers(response.data.data);
        }).catch(err => { console.error(err); setLoading(false); });
    }

    const loadModules = () => {
        setLoading(true);
        get(`${apiConstants.BASE_LOCAL}${apiConstants.LIST_MODULES}`).then(response => {
            const moduleList = response.data?.filter((val) => val !== "INTERNAL")
            setLoading(false);
            setModules(moduleList);
        })
            .catch(err => { console.error(err); setLoading(false); });
    }

    const handleEditClick = (id) => {
        const result = findInObjArr(userList, id, "id");
        setCurrentId(result);
    }

    const handletoggleStatus = (id, status) => {

        setCurrentId(null);
        setLoading(true);
        const result = findInObjArr(userList, id, "id");
        const payload = {
            "username": result.username,
            "actionType": (status === "ACTIVE") ? "DEACTIVATE" : "ACTIVATE"
        };
        post(`${apiConstants.BASE_LOCAL}${apiConstants.UPDATE_USER_ACTION}`, payload)
            .then(response => {
                setLoading(false);
                handleClose();
                loadUsers();

            })
            .catch(err => { console.error(err); setLoading(false); });

    }

    const toggleStatus = (id, status) => {
        const actionType = (status === "ACTIVE") ? "DEACTIVATE" : "ACTIVATE"
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-ui">
                        <h1>Are you sure?</h1>
                        <p>You want to {titleCase(actionType)}?</p>
                        <button className="btn btn-outline-primary btn-previous me-md-4 me-2 mt-0" onClick={onClose}>No</button>
                        <button
                            className="btn btn-primary btn-previous me-md-4 me-2 mt-0 onboarding-btn"
                            onClick={() => {
                                handletoggleStatus(id, status);
                                onClose();
                            }}
                        >
                            Yes, {titleCase(actionType)}
                        </button>
                    </div>
                );
            }
        });
    };

    const handleTogglePiiAccess = (id, currentPiiAccess) => {
        setLoading(true);
        const result = findInObjArr(userList, id, "id");
        const newPiiAccess = !(currentPiiAccess === true || currentPiiAccess === 'true');
        const payload = {
            username: result.email || result.username,
            accessModules: result.accessList || [],
            piiAccess: newPiiAccess
        };
        post(`${apiConstants.BASE_LOCAL}${apiConstants.UPDATE_USER_ROLE}`, payload)
            .then(response => {
                setLoading(false);
                toast.success(newPiiAccess ? 'PII Access granted successfully' : 'PII Access removed successfully');
                loadUsers();
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
                toast.error(err?.response?.data?.message || 'Failed to update PII access');
            });
    };

    useEffect(() => {
        loadModules()
        loadUsers();
    }, [reload]);

    return (
        <>
            <PageTitle>User Management</PageTitle>
            <div id="main-content" className="container-fluid">
                {/* <PageHero
                    title="User Management"
                    subtitle="Manage panel users and their access"
                    sx={{ mb: 2.5 }}
                /> */}
                {loading &&
                    <Loader />
                }

                {(!userList || userList.length === 0) &&
                    <UserNotFound handleShow={handleShow} />
                }
                {(userList && userList.length > 0) &&
                    <UserList
                        userList={userList}
                        handleShow={handleShow}
                        handleShowApiUser={handleShowApiUser}
                        handleEditClick={handleEditClick}
                        toggleStatus={toggleStatus}
                        handleTogglePiiAccess={handleTogglePiiAccess}
                        setReload={setReload}
                    />
                }

            </div>
            <AddUser
                show={show}
                loadUsers={loadUsers}
                handleClose={handleClose}
                moduleList={moduleList}
                currentUser={currentId}
                setCurrentId={setCurrentId}
            />
            <AddApiUser
                show={showApiUser}
                handleClose={handleCloseApiUser}
                loadUsers={loadUsers}
            />
        </>
    );
}
export default withLayout(MerchantUsers);